import { fetch_sadap } from '../../../../core/api'

const report_create = (params) => {
    const path = "report/create"
    const method = "POST"
    return fetch_sadap(
        path,
        method,
        params,
        false
    )
}

export default report_create;

export const report_update = (params) => {
    const path = "report/update"
    const method = "PUT"
    return fetch_sadap(
        path,
        method,
        params,
        false
    )
}

export function report_delete(id) {
    const path = `report/delete?id=${id}`
    const method = "delete"
    return fetch_sadap(
        path,
        method,
        {},
        false
    )
}